export default "__VITE_ASSET__D7KjOcn0__"